import { render, staticRenderFns } from "./NavMegaMenu.vue?vue&type=template&id=24fe44f2&scoped=true"
import script from "./NavMegaMenu.vue?vue&type=script&lang=js"
export * from "./NavMegaMenu.vue?vue&type=script&lang=js"
import style0 from "./NavMegaMenu.vue?vue&type=style&index=0&id=24fe44f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe44f2",
  null
  
)

export default component.exports